import { useTranslation } from 'react-i18next';
import React from 'react';
import { AxiosResponse } from 'axios';
import { Namespace } from '../../../translation/namespace';
import { SonApiResponse } from '../../../types/api/SonApiResponse';
import { InteractionStatus } from '../../../types/InteractionStatus';

export type ErrorResponse = { originalFilename: string; message: string; errorType: string };

// in case we need to manually gather errors and dont want to create a AxiosResponseObject
type ManualErrors = { data: SonApiResponse[] };

type FileUploadResponseErrors = AxiosResponse<SonApiResponse | SonApiResponse[]> | ManualErrors;

type FileUploadResponseErrorsProps = {
  response?: FileUploadResponseErrors;
  status: InteractionStatus | string;
  maxWidth?: number;
  maxHeight?: number;
};

export function isErrorResponse(response: SonApiResponse): response is ErrorResponse {
  return !!(response.errorType && response.originalFilename && response.message);
}

export const getErrorFilesFromResponse = (response?: FileUploadResponseErrors): ErrorResponse[] => {
  return response && Array.isArray(response.data) ? response.data.filter(isErrorResponse) : [];
};

export function FileUploadResponseErrors({ response, status, maxWidth, maxHeight }: FileUploadResponseErrorsProps) {
  const { t } = useTranslation(Namespace.FileUpload);

  const errors = getErrorFilesFromResponse(response);

  if (status !== InteractionStatus.FAIL || errors.length === 0) {
    return null;
  }

  return (
    <ul className="file-upload__upload-error-messages">
      {errors.map(({ errorType, originalFilename }) => (
        <li className="file-upload__upload-error-messages-list-item" key={originalFilename + errorType}>
          {t(`uploadFail.${errorType}`, { originalFilename, maxWidth, maxHeight })}
        </li>
      ))}
    </ul>
  );
}
